<template>
    <div class="item" @click="onClick(notice)" :class="{new: !notice.read_at}">
        <div class="title">
            <span>補刷</span><div>{{ notice.title }}</div>
        </div>
        <div class="content">{{ notice.content }}</div>
        <div class="bottom">
            <div class="date">{{ notice.created_at | date }}</div>
            <div class="order">
                任務＃{{ notice.data.order_id }}
                <img src="@/assets/img/task.svg">
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "PaymentChange",
        props: {
            notice: {
                require: true,
                type: Object,
            }
        },
        methods: {
            onClick(notice) {
                if (! notice.data.order_id) {
                    return;
                }

                this.$router.push({name: 'order', params: {id: notice.data.order_id}});
            },
        },
        filters: {
            date(date) {
                return moment(date).format('MM/DD hh:mm');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .item {
        padding: 10px;
        text-align: left;
        border: 1px solid #DDDDDD;
        box-sizing: border-box;
        border-radius: 5px;
        background-color: #FFFFFF;
        margin: 5px 0;

        &.new {
            border: 1px solid #339933;
            background-color: #F5FAF5;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        }

        .title {
            display: flex;
            font-size: 16px;
            font-weight: 600;
            color: #000000;
            align-items: center;

            span {
                border-radius: 5px;
                background-color: #4A90E2;
                padding: 2px 10px;
                color: #FFFFFF;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                margin-right: 5px;
            }
        }

        .content {
            color: #000000;
            font-size: 14px;
            margin-top: 5px;
            white-space: pre-line;
        }

        .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 7px;

            .date {
                font-size: 13px;
                color: #9B9B9B;
                font-weight: 400;
            }

            .order {
                display: flex;
                align-items: center;
                color: #339933;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 20px;
            }
        }
    }
</style>